import { DateTime } from 'luxon';
import { RenderIf } from 'react-rainbow-components';
import { useNexhealthPatientAlerts } from '../hooks';
import {
    AlertDate,
    AlertItem,
    Section,
    SectionHeader,
    SectionTitle,
} from './styled';

const Alerts = ({ agentId, patientId }: { agentId: string; patientId: number }) => {
    const { data } = useNexhealthPatientAlerts(agentId, patientId, true);
    const alerts = (data?.data || []).filter((alert) => !alert.disabled_at && alert.note);

    if (alerts.length === 0) return null;

    return (
        <Section>
            <SectionHeader>
                <SectionTitle>Alerts</SectionTitle>
            </SectionHeader>
            {alerts.map((alert) => (
                <AlertItem key={alert.id}>
                    {alert.note}
                    <RenderIf isTrue={alert.created_at}>
                        <AlertDate>
                            {DateTime.fromISO(alert.created_at || '').toLocaleString(DateTime.DATE_MED)}
                        </AlertDate>
                    </RenderIf>
                </AlertItem>
            ))}
        </Section>
    );
};

export default Alerts;
